import { FinanceCardType } from '../constants';

export default function getFinanceCardType(
  hasValidSoftPull: boolean,
  hasExpiredSoftPull: boolean
): FinanceCardType {
  switch (true) {
    case hasValidSoftPull:
      return FinanceCardType.Active;
    case hasExpiredSoftPull:
      return FinanceCardType.Expired;
    default:
      return FinanceCardType.Default;
  }
}
